import React from 'react';
import { AlertCircle } from 'lucide-react';

export interface AccessDeniedMessageProps {
  message?: string;
  requiredRoles?: string[];
  onBack?: () => void;
}

export const AccessDeniedMessage = ({
  message = 'Bu kullanıcılara erişmek için gerekli yetkilere sahip değilsiniz.',
  requiredRoles = [],
  onBack,
}: AccessDeniedMessageProps) => {
  return (
    <div className="p-4 sm:p-6 lg:p-8 bg-gradient-to-br from-gray-50 to-white min-h-screen flex items-center justify-center">
      <div className="text-center p-8 bg-white rounded-xl shadow-lg max-w-md w-full">
        <div className="mb-4 flex justify-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <AlertCircle className="w-8 h-8 text-red-600" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Erişim Reddedildi</h2>
        <p className="text-gray-600 mb-4">{message}</p>
        {requiredRoles.length > 0 && (
          <p className="text-sm text-gray-500 mb-6">
            Gerekli roller: <span className="font-semibold">{requiredRoles.join(', ')}</span>
          </p>
        )}
        {onBack && (
          <button
            onClick={onBack}
            className="px-6 py-2 bg-accent text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Geri Dön
          </button>
        )}
      </div>
    </div>
  );
};
